<template>
  <div>
    <div class="banner_box">
      <img  src="../assets/images/banner-500/parnter.jpg">
    </div>
    <div class="div-img-top1 body-width divcss5 partner_font">
      <div class="font_zh">
        {{$t("cooperation.partner")}}
      </div>
      <div class="font_en font_en_top">
        COOPERATIVE PARTNER
      </div>
    </div>
    <div class="partner_box">
      <cooperationcontent></cooperationcontent>
    </div>
  </div>
</template>

<script>
    import cooperationcontent from "@/components/contentcoms/cooperationcontentcoms/cooperationcontent";
    import banner from "@/components/commoncoms/banner";
    export default {
      name: "cooperation",
      components: {cooperationcontent,banner}
    }
</script>

<style scoped>
  .partner_box{
    width: 1200px;
    margin: 0 auto;
    /* padding-top: 50px; */
  }
  .partner_font{
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/cooperation.vue